import { RemoteConfigVariables } from 'fitbeat.models';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { FirebaseConfigText } from '../../ui';

interface IProps {
  logout(): void;
  joinNow(): void;
  t(key: string): string;
}

export const IAPCloseScreenModal = ({ t, joinNow, logout }: IProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <Text style={styles.header}>{t('auth:closingScreenLogout')}</Text>
        <FirebaseConfigText style={styles.subHeader}
                            remoteConfigKey={RemoteConfigVariables.in_app_purchase_close_modal_sub_header}
        />
        <View style={styles.buttonContainer}>
          <Button
            title={t('auth:logout')}
            fontColor={Theme.GREY_DARK}
            containerStyle={{ marginTop: 3 }}
            onPress={logout}
            buttonType={ButtonTypes.TRANSPARENT}
            overrideFontStyles={{ fontFamily: Theme.Custom800 }}
          />
          <Button
            title={t('auth:joinNow')}
            fontColor={Theme.GREY_DARK}
            containerStyle={{ marginTop: 3 }}
            onPress={joinNow}
            buttonType={ButtonTypes.TRANSPARENT}
            overrideFontStyles={{ fontFamily: Theme.Custom800 }}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  innerContainer: {
    margin: 15,
    paddingTop: 40,
    paddingBottom: 20,
    paddingHorizontal: 20,
    borderRadius: 10,
    backgroundColor: Theme.WHITE,
  },
  header: {
    fontSize: 18,
    color: Theme.BLACK,
    textAlign: 'center',
    fontFamily: Theme.Custom700,
  },
  subHeader: {
    fontSize: 16,
    color: Theme.BLACK,
    textAlign: 'center',
    paddingVertical: 20,
    fontFamily: Theme.Custom500,
  },
  buttonContainer: {
    borderTopWidth: 0.5,
    paddingTop: 10,
    flexDirection: 'row',
    justifyContent: 'space-around',
    borderTopColor: Theme.GREY_DARK,
  },
});
